'use client';

import {QueryClientProvider} from '@tanstack/react-query';
import dynamic from 'next/dynamic';
import {LocaleProvider} from './_contexts/locale-context';
import {getQueryClient} from './get-query-client';

const ReactQueryDevtools =
    process.env.NODE_ENV === 'production'
        ? null
        : dynamic(
            () => import('@tanstack/react-query-devtools').then(m => m.ReactQueryDevtools),
            {ssr: false}
        );

export function Providers({children}: { children: React.ReactNode }) {
    const queryClient = getQueryClient();

    return (
        <QueryClientProvider client={queryClient}>
            <LocaleProvider>
                {children}
            </LocaleProvider>
            {ReactQueryDevtools && <ReactQueryDevtools initialIsOpen={false} buttonPosition="top-right" />}
        </QueryClientProvider>
    );
}
